import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nameInput", "saveButton", "feedback"]
  static values = { url: String, calculatorType: String }

  save() {
    const name = this.nameInputTarget.value.trim()
    if (!name) {
      this.showFeedback("Enter a name first", "text-amber-600")
      return
    }

    this.saveButtonTarget.disabled = true
    this.saveButtonTarget.textContent = "Saving..."

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const body = {
      calculator_type: this.calculatorTypeValue,
      name: name,
      inputs: this.collectInputs()
    }

    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        Accept: "application/json"
      },
      body: JSON.stringify(body)
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.id) {
          this.showFeedback("Saved!", "text-emerald-600")
          this.nameInputTarget.value = ""
        } else {
          const msg = data.errors?.join(", ") || data.error || "Save failed"
          this.showFeedback(msg, "text-red-600")
        }
      })
      .catch(() => {
        this.showFeedback("Network error", "text-red-600")
      })
      .finally(() => {
        this.saveButtonTarget.disabled = false
        this.saveButtonTarget.textContent = "Save Scenario"
      })
  }

  collectInputs() {
    const params = new URLSearchParams(window.location.search)
    const inputs = {}
    for (const [key, value] of params) {
      inputs[key] = value
    }
    const form = this.element.closest("[data-controller]")?.querySelector("form")
    if (form) {
      const formData = new FormData(form)
      for (const [key, value] of formData) {
        inputs[key] = value
      }
    }
    return inputs
  }

  showFeedback(message, cssClass) {
    this.feedbackTarget.textContent = message
    this.feedbackTarget.className = `text-sm ${cssClass}`
    this.feedbackTarget.classList.remove("hidden")
    setTimeout(() => {
      this.feedbackTarget.classList.add("hidden")
    }, 3000)
  }
}
